import { z } from 'zod';

export const PAYMENT_DETAILS_NAME_MAX_LENGTH = 100;
/** Matches the QuickBooks CustomerMemo ("Message on invoice") limit. */
export const PAYMENT_DETAILS_TEXT_MAX_LENGTH = 1000;

export const paymentDetailsSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'authenticated.settings:pages.finance.paymentDetails.validation.nameRequired')
    .max(
      PAYMENT_DETAILS_NAME_MAX_LENGTH,
      'authenticated.settings:pages.finance.paymentDetails.validation.nameTooLong'
    ),
  details: z
    .string()
    .trim()
    .min(1, 'authenticated.settings:pages.finance.paymentDetails.validation.detailsRequired')
    .max(
      PAYMENT_DETAILS_TEXT_MAX_LENGTH,
      'authenticated.settings:pages.finance.paymentDetails.validation.detailsTooLong'
    ),
  isDefault: z.boolean(),
});

export type PaymentDetailsFormValues = z.infer<typeof paymentDetailsSchema>;
